<script>
  import Link from 'svelte-routing/src/Link.svelte';
  import User from './Components/Chat/User/User.svelte';
  import { user, singleChatId } from './Store/store';

  import MobileMenu from './MobileMenu.svelte';
  import { fade } from 'svelte/transition';

  let activeHref = '';

  function getProps({ location, href, isPartiallyCurrent, isCurrent }) {
    const isActive = href === '/' ? isCurrent : isPartiallyCurrent || isCurrent;
    if (isActive) {
      activeHref = href;
      return { class: 'active' };
    }
    return {};
  }
</script>

<header class="banner" in:fade>
  <Link to={'/'}><img class="logo" src="/assets/tv2-logo.svg" alt="" /></Link>
  {#if $singleChatId}
    <div class="right-aligned">
      {#if $user}
        <div class="user">
          <User />
        </div>
      {/if}
    </div>
  {:else}
    <nav class="navigation">
      <Link to={`/chat`} {getProps}>Chat</Link>
      <!-- <Link to={`/meldinger`} {getProps}>Meldinger</Link>
      <Link to={`/spillelister`} {getProps}>Spillelister</Link>
      <Link to={`/profiler`} {getProps}>Profiler</Link> -->
    </nav>
    <div class="right-aligned">
      {#if $user}
        <div class="user">
          <User />
        </div>
      {/if}
      <div class="mobile-menu">
        <MobileMenu />
      </div>
    </div>
  {/if}
</header>

<style src="./appHeader.scss">
</style>
